import React from "react";
import { useViewport, config, service } from "../utils";

const Title = ({
  item,
  updateCurrentModal,
  handleClick
}) => {
  const { width, breakpoint } = useViewport();

  const handleTitleClick = () => {
    service.trackClick(config.NEED_HELP_TRACKING.NEED_HELP, item.eventName);
    if (item.linkedPage) {
      updateCurrentModal(item.linkedPage.modalId);
      return;
    }
    handleClick(item)
  };

  return (
    <React.Fragment>
      <h3
        onClick={handleTitleClick}
        className={`${
          width < breakpoint
            ? "needHelpTileMobTxt2"
            : "needHelpTileMobTxt"
        }`}
      >
        {item.pageTitle}
        {!item.linkedPage &&
          <span className={`arrow--blue ${!item.isActive ? 'down': 'up'}`}></span>
        }
      </h3>
      {item.linkedPage && (
        <a
          onClick={handleTitleClick}
          className={`needHelpTile__Link ${
            width > breakpoint ? "font18" : "font14"
          } latoBold textRight`}
        >
          {item.linkedPage.linkTitle}
        </a>
      )}
    </React.Fragment>
  );
}

export default Title;
